import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {InstructorCard} from "./InstructorCard";

export const InstructorsList = ({
    instructors = [],
    isLoading = false,
    onLocate,
    selectedInstructorId = null,
    onResetFilters,
    onExpressInterest,
}) => {
    if (isLoading) {
        return (
            <Box sx={{ p: 4, textAlign: "center" }} role="status" aria-live="polite">
                <Typography color="textSecondary">Laster inn kursholdere...</Typography>
            </Box>
        );
    }

    if (instructors.length === 0) {
        return (
            <Box
                sx={{
                    p: 4,
                    textAlign: "center",
                    bgcolor: "background.paper",
                    borderRadius: 3,
                    border: "1px dashed #EAE6DF",
                    my: 2,
                }}
                role="status"
            >
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "text.primary" }}>
                    Ingen kursholdere funnet
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Prøv å endre søkeordet ditt eller velg et annet fylke for å se tilgjengelige kursholdere.
                </Typography>
                {typeof onResetFilters === "function" && (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={onResetFilters}
                        aria-label="Vis alle kursholdere og nullstill filtre"
                        sx={{
                            minHeight: 44,
                            minWidth: 44,
                            "&:focus-visible": {
                                outline: "2px solid #285238",
                                outlineOffset: "2px",
                            },
                        }}
                    >
                        Vis alle kursholdere
                    </Button>
                )}
            </Box>
        );
    }

    return (
        <Box sx={{ width: "100%" }}>
            {instructors.map(instructor => (
                <InstructorCard
                    key={instructor.id}
                    instructor={instructor}
                    isSelected={selectedInstructorId === instructor.id}
                    onLocate={onLocate}
                    onExpressInterest={onExpressInterest}
                />
            ))}
        </Box>
    );
};